import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The app root renders nothing of its own — it hands off to Home, the default landing page.
 *
 * The patient list lived here until Home took over as the landing page, so a root URL that
 * carries the list's view state (`/?search=…`, a bookmarked page of results) is still a place someone
 * asked for: it forwards to `/patients` with the query string intact. A bare `/` — typing the domain,
 * or coming back from sign-in with nothing to restore — has no such state and lands on Home.
 */
export const Route = createFileRoute('/_auth/')({
  beforeLoad: ({ location }) => {
    if (location.searchStr === '') throw redirect({ to: '/home' });
    throw redirect({ href: `/patients${location.searchStr}` });
  },
});
